import React, { useEffect, useState } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { AnimatePresence } from 'framer-motion';
import { Loader } from './components/Loader';
import { Nav } from './components/Nav';
import { Footer } from './components/Footer';
import { FloatingSearch } from './components/FloatingSearch';
import { FloatingActions } from './components/FloatingActions';
import { IntentCapture } from './components/IntentCapture';
// Pages
import { Home } from './pages/Home';
import { Houses } from './pages/Houses';
import { Land } from './pages/Land';
import { Blog } from './pages/Blog';
import { Contact } from './pages/Contact';
import { WhoWeAre } from './pages/WhoWeAre';
import { BoardOfDirectors } from './pages/BoardOfDirectors';
import { ManagementTeam } from './pages/ManagementTeam';
import { Certifications } from './pages/Certifications';
import { Testimonials } from './pages/Testimonials';
import { BlogPost } from './pages/BlogPost';
import { PropertyDetail } from './pages/PropertyDetail';
import { ScrollToTop } from './components/ScrollToTop';
export function App() {
  const [isLoading, setIsLoading] = useState(true);
  // Lock scroll while loading
  useEffect(() => {
    if (isLoading) {
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.overflow = '';
    }
    return () => {
      document.body.style.overflow = '';
    };
  }, [isLoading]);
  return <BrowserRouter data-id="element-0">
      <main className="min-h-screen bg-bone selection:bg-gold selection:text-ink flex flex-col" data-id="element-1">
        {/* Global Chrome */}
        <Nav data-id="element-2" />

        <ScrollToTop data-id="element-3" />
        {/* Main Content Area */}
        <div className="flex-grow" data-id="element-4">
          <Routes data-id="element-5">
            <Route path="/" element={<Home data-id="element-7" />} data-id="element-6" />
            <Route path="/houses" element={<Houses data-id="element-9" />} data-id="element-8" />
            <Route path="/houses/:slug" element={<PropertyDetail data-id="element-11" />} data-id="element-10" />
            <Route path="/land" element={<Land data-id="element-13" />} data-id="element-12" />
            <Route path="/land/:slug" element={<PropertyDetail data-id="element-15" />} data-id="element-14" />
            <Route path="/who-we-are" element={<WhoWeAre data-id="element-17" />} data-id="element-16" />
            <Route path="/management-team" element={<ManagementTeam data-id="element-19" />} data-id="element-18" />
            <Route path="/board-of-directors" element={<BoardOfDirectors data-id="element-21" />} data-id="element-20" />
            <Route path="/certifications" element={<Certifications data-id="element-23" />} data-id="element-22" />
            <Route path="/blog" element={<Blog data-id="element-25" />} data-id="element-24" />
            <Route path="/blog/:slug" element={<BlogPost data-id="element-27" />} data-id="element-26" />
            <Route path="/testimonials" element={<Testimonials data-id="element-29" />} data-id="element-28" />
            <Route path="/contact" element={<Contact data-id="element-31" />} data-id="element-30" />
          </Routes>
        </div>

        {/* Global Chrome */}
        <Footer data-id="element-32" />
        <FloatingSearch data-id="element-33" />
        <FloatingActions data-id="element-34" />
        <IntentCapture data-id="element-35" />

        <AnimatePresence data-id="element-36">
          {isLoading && <Loader key="loader" onFinish={() => setIsLoading(false)} data-id="element-37" />}
        </AnimatePresence>
      </main>
    </BrowserRouter>;
}